import React, { useState, useEffect, useRef } from 'react';
import { StyledInput } from './styles';

export const NumberInputField = (props) => {
  const { error } = props.meta;
  const inputRef = useRef(null);
  const [displayValue, setDisplayValue] = useState(props.input.value || 0);

  useEffect(() => {
    setDisplayValue(props.input.value || 0);
  }, [props.input.value]);

  const handleChange = (e) => {
    let rawValue = e.target.value;

    rawValue = rawValue.replace(/,/g, '.');
    rawValue = rawValue.replace(/\s+/g, '');

    let filtered = '';
    let hasDecimal = false;

    for (let i = 0; i < rawValue.length; i++) {
      const char = rawValue[i];
      if (char >= '0' && char <= '9') {
        filtered += char;
      } else if (char === '.') {
        if (!hasDecimal) {
          filtered += char;
          hasDecimal = true;
        }
      }
    }

    if (filtered === '' || filtered === '.') {
      setDisplayValue(filtered);
      props.input.onChange(null);
      return;
    }

    const numberValue = parseFloat(filtered);
    if (!isNaN(numberValue)) {
      setDisplayValue(filtered);
      props.input.onChange(numberValue);
    } else {
      setDisplayValue(filtered);
      props.input.onChange(null);
    }
  };

  const handleFocus = (e) => {
    e.target.select();
    if (props.input.onFocus) props.input.onFocus(e);
  };

  return (
    <StyledInput
      ref={inputRef}
      type="text"
      name={props.input.name}
      value={displayValue}
      placeholder={props.placeholder || ''}
      inputMode="decimal"
      onChange={handleChange}
      onBlur={props.input.onBlur}
      onFocus={handleFocus}
      $error={error}
      autoComplete="off"
    />
  );
};
